import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=5210610c&scoped=true"
import script from "./Rankings.vue?vue&type=script&lang=js"
export * from "./Rankings.vue?vue&type=script&lang=js"
import style0 from "./Rankings.vue?vue&type=style&index=0&id=5210610c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210610c",
  null
  
)

export default component.exports